// extracted by mini-css-extract-plugin
module.exports = {"table":"modify-member-roles-modal_table__2VA-A","saveButton":"modify-member-roles-modal_saveButton__1C9YT"};